import {get, capitalize} from "lodash";
import {isValid, parse, format} from "date-fns";
import {useLocation} from "react-router-dom";
import {DATE_FORMAT} from "@reside/ui/dist/date-picker/date";

import {MAIN_URLS} from "../../store/reporting/reporting.common";
import {UrlProps} from "./ReportingBlock.types";

const FIELD_NAME_REGEX = /([A-Z][a-z])/g;

export const formatFieldName = (fieldName: string) => {
  return capitalize(
    fieldName.replace(FIELD_NAME_REGEX, " $1").trim().toLowerCase(),
  );
};

export const formatUnderscoreStrings = (fieldName: string) => {
  return capitalize(fieldName.replace("_", " ").trim().toLowerCase());
};

export const formatData = (data: any[]) =>
  data.map((row: any[]) => {
    return row.map((cell: any) => {
      if (typeof cell === "boolean") {
        return cell ? "Yes" : "No";
      } else if (isValid(parse(cell, DATE_FORMAT.ISO_DATE, null))) {
        return format(
          parse(cell, DATE_FORMAT.ISO_DATE, null),
          DATE_FORMAT.FULL_DATE,
        );
      }

      return cell;
    });
  });

export const formatHeaders = (headers: string[]) =>
  headers.map(formatFieldName);

export const linkBack = (
  urlProps: UrlProps | undefined,
  location: ReturnType<typeof useLocation>,
) => {
  const urlParts = [MAIN_URLS.OVERVIEW];
  const fromOverview = get(location, "state.fromOverview", false);

  if (!fromOverview && urlProps?.chartGroup) {
    urlParts.push(urlProps.chartGroup);
  }

  return `${urlParts.join("/")}#${urlProps?.chartId}`;
};
